import { Component, OnInit, Output, EventEmitter, ViewChild, OnDestroy, Input, AfterViewInit} from '@angular/core';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { CommonFilter } from 'src/app/shared/models/Common/common-filter';
import { Status, DaysOfMonth, Weekdays, Months } from 'src/app/shared/models/Scheduler/scheduler-status';
import { environment } from 'src/environments/environment';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { Router, NavigationEnd } from '@angular/router';
import { SCHEDULER, SCHEDULER_RECURRENCE, SCHEDULER_EMAILANDSMS } from 'src/app/shared/models';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Subscription } from 'rxjs';
 
@Component({
  selector: 'app-scheduler-status',
  templateUrl: './scheduler-status.component.html',
  styleUrls: ['./scheduler-status.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),

    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [
        animate(300, style({ opacity: 0 }))
      ])
    ]),

    trigger('simpleFadeAnimation', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(600)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(600, style({ opacity: 0 })))
    ]),
  ],

})
export class SchedulerStatusComponent implements OnInit, AfterViewInit {

  baseUrl: string;
  url: string;
  rsltType: string = "Scheduler";
  title: string;
  staticScreen = true;
  isLoading = false;
  isSubLoading = {};
  data2: any;
  goToPage = null;

  //For Enum object instantiation - IMP
  StatusEnum = Status;

  schID: number = 0;
  isProfile: boolean = true;
  isProfileCheck: boolean = true;
  noRecordFound: boolean = false;

  private commonFilter: CommonFilter;
  private scheduler: SCHEDULER;

  @Input() StatusVquadID: number = 0;

  //private generalFilterArray: Array<GeneralFilter>;
  @Output() childTitleEvent = new EventEmitter();

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  //dataSource = new MatTableDataSource();

  dataSource = new MatTableDataSource<any>([]);//: any[]; //new MatTableDataSource(); //[];
  dataSource2 = [];

  //'select', 'RowExpand', 'Edit', 'Add', 'NodeIP_Abs'
  //'select', 
  columnsToDisplay = ['RowExpand', 'ReportName_Abs', 'Description_Abs', 'ClientTimeStamp_Abs', 'OccurrencePattern_Abs', 'LatestExecDate_Abs', 'ExecsCount_Abs', 'Status_Abs'];

  SetIPType(LocalIPType_Abs) {
    return LocalIPType_Abs == "0" ? "Auto Get Local IP" : (LocalIPType_Abs == "1" ? "Get Local IP from ..\\Profiles\\LocalIP.ini" : "Use this as Local IP");
  }
  isDisabled = {};
  onSelectionChanged(matSelected, index) {
    //console.log(matSelected.value)
    if (matSelected.value == "2")
      this.isDisabled[index] = false;
    else
      this.isDisabled[index] = true;
  }

  schContactsColumns = ['ContactName_Abs', 'Country_Code_Abs', 'SMS_Number_Abs', 'EMail_Address_Abs'];

  expandedElement: PeriodicElement | null;

  tableDef: Array<any> = [
    {
      key: 'ID_Abs',
      header: 'ID'
    },
    {
      key: 'ReportName_Abs',
      header: 'Name'
    }, {
      key: 'Description_Abs',
      header: 'Description'
    }, {
      key: 'ClientTimeStamp_Abs',
      header: 'Created on'
    },
    {
      key: 'OccurrencePattern_Abs',
      header: 'Occurrence Pattern'
    }, {
      key: 'LatestExecDate_Abs',
      header: 'Next/Final Execution Date (Central DB Timezone)'
    }, {
      key: 'ExecsCount_Abs',
      header: 'No of Executions happened'
    }, {
      key: 'Status_Abs',
      header: 'Status'
    },
  ]

  // MatPaginator Inputs
  length = 100;
  pageSize = 20;
  pageSizeOptions: number[] = [1, 10, 25, 100];
  pageIndex = 0;

  // MatPaginator Output
  pageEvent: PageEvent;
  //mySubscription: any;

  AutoRefreshInfo: any;
  interval;

  private subscriptions: Subscription[] = [];
  constructor(private commonFilterService: CommonFilterService, private http: HttpClient, private dialog: MatDialog, private router: Router, public datepipe: DatePipe) {
    this.baseUrl = environment.urlAddress + '/api/';

    this.commonFilterService.setNonFiltersScreen(this.staticScreen);

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        this.LoadSchedulerData();
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(res)
        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);

            this.LoadSchedulerData();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);
  }
  //ngOnDestroy() {
  //  if (this.mySubscription) {
  //    this.mySubscription.unsubscribe();
  //  }
  //}

  OnReloadRoute() {
    //this.router.navigateByUrl('statistics/scheduler');
    this.LoadSchedulerData();
  }

  ngOnInit() {
   //debugger
   //this.router.routeReuseStrategy.shouldReuseRoute = function () {
   //   return false;
   // };
   // this.mySubscription = this.router.events.subscribe((event) => {
   //   if (event instanceof NavigationEnd) {
   //     // Trick the Router into believing it's last link wasn't previously loaded
   //     this.router.navigated = false;

   //     // if you need to scroll back to top, here is the right place
   //     window.scrollTo(0, 0);
   //   }
   // });

    this.LoadSchedulerData();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  updateManualPage() {
    //debugger;
    // this.manualPage = index;
    this.paginator.pageIndex = this.goToPage - 1;
    this.LoadSchedulerData(this.paginator);
  }

  ngAfterViewInit() {
    //setTimeout(() => this.dataSource.paginator = this.paginator);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  GetFormatedDate(dt) {
    ///// https://www.codegrepper.com/code-examples/javascript/date+format+angular
    if (dt == null)
      return "";

    let formatedDate = dt.toString().length > 0 ? this.datepipe.transform(new Date(dt), 'short') : "";
    return formatedDate;
  }

  //load default data
  currentPage: number;
  completedSchedulesOrNot: boolean=false;
  setCompleted() {
    this.completedSchedulesOrNot = !this.completedSchedulesOrNot;
    this.LoadSchedulerData();
  }
  LoadSchedulerData(event?: PageEvent) {
    //debugger;
    this.isLoading = true;
    this.commonFilter = new CommonFilter();
    this.commonFilter.ResultOrFileType = this.completedSchedulesOrNot == false ? 5 : 7;

    if (event != undefined) {

      this.currentPage = +event.pageIndex + +1;
      this.url = this.baseUrl + 'SchedulerStatus/GetSchedulers_New';
      this.commonFilter.PerPage = event.pageSize.toString();
      this.commonFilter.PageNumber = this.currentPage.toString();

    } else {
      this.url = this.baseUrl + 'SchedulerStatus/GetSchedulers_New';
      this.commonFilter.PerPage = this.pageSize.toString();
      this.commonFilter.PageNumber = "1";
    }

    this.GetData(this.commonFilter).subscribe((res: any) => {
      if (res !== 'null') {
        let rows: SCHEDULER[] = JSON.parse(res) as any[];
        let newRows = [];
        this.length = rows.length;
        for (const index in rows) {
          //let execDate = rows[index].Report_Start_Timestamp.toString().length > 0 ? (rows[index].Report_Start_Timestamp.getFullYear() < new Date().getFullYear() ? "" : rows[index].Report_Start_Timestamp.toString()) : "";
          ///// https://www.codegrepper.com/code-examples/javascript/date+format+angular
          let execDate = rows[index].Report_Start_Timestamp.toString().length > 0 ? (new Date(rows[index].Report_Start_Timestamp).getFullYear() < new Date().getFullYear() ? "" : this.GetFormatedDate(rows[index].Report_Start_Timestamp)) : "";
          let currNoofTimes = rows[index].CurrGenNoOfTimes;
          // let createOnDate = rows[index].ClientTimeStamp.toString().length > 0 ? this.datepipe.transform(new Date(rows[index].ClientTimeStamp), 'short') : "";
          let eachNewRow = {
            ID_Abs: rows[index].ID, ReportName_Abs: rows[index].ReportName, Description_Abs: rows[index].Description, ClientTimeStamp_Abs: this.GetFormatedDate(rows[index].ClientTimeStamp),
            OccurrencePattern_Abs: '', LatestExecDate_Abs: execDate, ExecsCount_Abs: currNoofTimes, Status_Abs: rows[index].Report_Latest_Status
          };

          let cronString = "";
          let hrsAndMins = rows[index].RecurrenceHrsVal + " Hrs and " + rows[index].RecurrenceMinutesVal + " Mins";
          let noOfTimes = "";
          let totalNoofTimes = rows[index].TotalGenNoOfTimes.toString();
          let recurDate = 0;
          let sup = 0;
          let currDate: DaysOfMonth;
          switch (totalNoofTimes) {
            case "-2":
              totalNoofTimes = "1";
              hrsAndMins = "";
              if (rows[index].genEndBy != null && rows[index].genEndBy.length > 0) {
                cronString += "Only once on " + (rows[index].genEndBy != null ? this.GetFormatedDate(rows[index].genEndBy) : "");

              }
              else {
                cronString += "At once";
              }
              break;
            default:
              this.GetRecurrence(rows[index].ReportName).subscribe((res: any) => {
                let dummy: SCHEDULER_RECURRENCE[] = JSON.parse(res) as any[];
                if (dummy != null) {
                  if (dummy.length > 0) {
                    let parseVal = 1;

                    if (totalNoofTimes == "0")//End by particular date
                      noOfTimes = " till " + rows[index].genEndBy;
                    else if (totalNoofTimes == "-1")//Infinitely
                      noOfTimes = " endlessly";
                    else//Particular no of times
                      noOfTimes = " for " + totalNoofTimes + " time(s)";

                    switch (rows[index].RecurrenceType.toString()) {
                      case "1"://Hourly
                        cronString += "At every ";
                        break;
                      case "2"://Daily
                        cronString += "Daily at ";
                        break;
                      case "3"://Weekly
                        let weekType = dummy[0].RecurrenceDayOnEvery.toString();
                        weekType = weekType == "1" ? "1st" : (weekType == "2" ? "2nd" : (weekType == "3" ? "3rd" : (weekType == "4" ? "4th" : "5th")));
                        let daysOnEvery = dummy[0].RecurrenceDayOnEvery.toString() == "0" ? "" : weekType + " ";

                        cronString += "Only on " + daysOnEvery;
                        for (const subIndex in dummy) {
                          parseVal = 2;
                          let currWeekDay: Weekdays = dummy[subIndex].RecurrenceDay;
                          if (cronString.indexOf(currWeekDay.toString() + ", ") == -1)
                            cronString += currWeekDay.toString() + ", ";
                        }
                        cronString = cronString.trim().substring(0, cronString.length - parseVal) + " of every month at ";
                        break;
                      case "4"://Monthly
                        cronString += "On ";
                        for (const subIndex in dummy) {
                          parseVal = 2;
                          recurDate = dummy[subIndex].RecurrenceDate;
                          sup = 0;//1,21,31
                          if ((recurDate >= 4 && recurDate <= 20) || (recurDate >= 24 && recurDate <= 30))
                            sup = 3;
                          else if (recurDate == 2 || recurDate == 22)
                            sup = 1;
                          else if (recurDate == 3 || recurDate == 23)
                            sup = 2;
                          currDate = sup;

                          cronString += recurDate.toString() + currDate.toString() + ", ";
                        }
                        cronString = cronString.substring(0, cronString.length - parseVal) + " of every month at ";
                        break;
                      case "5"://Yearly
                        cronString += "In ";
                        recurDate = dummy[0].RecurrenceDate;
                        sup = 0;//1,21,31
                        if ((recurDate >= 4 && recurDate <= 20) || (recurDate >= 24 && recurDate <= 30))
                          sup = 3;
                        else if (recurDate == 2 || recurDate == 22)
                          sup = 1;
                        else if (recurDate == 3 || recurDate == 23)
                          sup = 2;
                        currDate = sup;

                        for (const subIndex in dummy) {
                          parseVal = 2;
                          let currMonth: Months = dummy[subIndex].RecurrenceMonth;
                          cronString += currMonth.toString() + ", ";
                        }
                        cronString = cronString.substring(0, cronString.length - parseVal) + " of every year on " + recurDate.toString() + currDate.toString() + " at ";
                        break;
                    }
                  }
                }
              });
              break;
          }
          cronString += hrsAndMins + noOfTimes;
          eachNewRow.OccurrencePattern_Abs = cronString;

          newRows.push(eachNewRow);
        }

        this.dataSource.data = newRows;
      }
      //this.length = rows.length;
      this.isLoading = false;
    },
      err => {
        this.isLoading = false;
      });

    return event;
  }

  /// expanded bind
  CallFunc(schName: string, elemRowIndex) {
    this.isSubLoading[elemRowIndex] = true;
    this.noRecordFound = false;

    this.GetEmailAndSMSData(schName).subscribe((res: any) => {
      let rows: SCHEDULER_EMAILANDSMS[] = JSON.parse(res) as any[];
      //console.log(rows);
      if (rows.length == 0)
        this.noRecordFound = true;

      let newRows = [];
      for (const index in rows) {
        let eachNewRow = { ContactName_Abs: rows[index].PersonName, Country_Code_Abs: rows[index].SMSCountryCode, SMS_Number_Abs: rows[index].SMSNumber, EMail_Address_Abs: rows[index].EMailAddress };
        newRows.push(eachNewRow);
      }

      this.dataSource2 = newRows;
      this.isSubLoading[elemRowIndex] = false;
    });
  }

  GetData(commFilter: CommonFilter) {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, commFilter, options);
  }

  GetEmailAndSMSData(schName: string) {

    this.url = this.baseUrl + 'SchedulerStatus/GetEmailAndSMSBySchID_New?schName=' + schName;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });
    //.map((data: Response) => {
    //  return data.json() as EachVqtPolqa[];
    //}).toPromise().then(x => {
    //  this.eachVqtPolqaList = x;
    //})
  }
  GetRecurrence(schName: string) {

    this.url = this.baseUrl + 'SchedulerStatus/GetRecurrenceBySchID_New?schName=' + schName;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });
    //.map((data: Response) => {
    //  return data.json() as EachVqtPolqa[];
    //}).toPromise().then(x => {
    //  this.eachVqtPolqaList = x;
    //})
  }

  parentEvent(title) {
    //debugger;

    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  //change status of schedule
  isPaused = {};
  PauseRow(rowData: any, rowIndex) {

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    dailogConfig.data = { title: "Confirm Action", message: "Are you sure you want to Pause Schedule?" };

    this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.isPaused[rowIndex] = !this.isPaused[rowIndex];

        this.PauseSchedule(rowData).subscribe((res: any) => {
          rowData.Status_Abs = -1;  /// -1 = Pause status
        });

        this.isLoading = true;
        setTimeout(() => { this.isLoading = false; this.OnReloadRoute(); }, 3000);
      }
    });
  }
  ResumeRow(rowData: any, rowIndex) {

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    dailogConfig.data = { title: "Confirm Action", message: "Are you sure you want to Resume Schedule?" };

    this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.isPaused[rowIndex] = !this.isPaused[rowIndex];

        this.ResumeSchedule(rowData).subscribe((res: any) => {
          rowData.Status_Abs = 1;  /// -1 = Resume status
        });

        this.isLoading = true;
        setTimeout(() => { this.isLoading = false; this.OnReloadRoute(); }, 3000);
      }
    });

  }

  PauseSchedule(rowData: any) {
    //debugger;

    this.url = this.baseUrl + 'SchedulerStatus/PauseSchStat_Main';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = {
      headers: headerOptions
    };
    //var body = {
    //  PageNumber: this.commonFilter.PageNumber, PerPage: this.commonFilter.PerPage
    //}
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.post<any>(this.url, '=' + rowData.ID_Abs, options);

  }
  ResumeSchedule(rowData: any) {
    //debugger;

    this.url = this.baseUrl + 'SchedulerStatus/ResumeSchStat_Main';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = {
      headers: headerOptions
    };
    //var body = {
    //  PageNumber: this.commonFilter.PageNumber, PerPage: this.commonFilter.PerPage
    //}
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.post<any>(this.url, '=' + rowData.ID_Abs, options);

  }

  ///////////////////// checkbox selection
  selection = new SelectionModel<any>(true, []);

  //** Whether the number of selected elements matches the total number of rows. */
  isAllSelected1() {

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource != null ? this.dataSource.data.length : 0;
    return numSelected === numRows;
  }

  //** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle1() {
    this.isAllSelected1() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  //** The label for the checkbox on the passed row */
  checkboxLabel1(id: number, row?: any): string {

    if (id == 1) {
      if (!row) {
        id = 0;
        return `${this.isAllSelected1() ? 'select' : 'deselect'} all`;

      }
      id = 0;
      return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }
    else {
      this.selection.deselect();
      this.selection.clear();
    }
  }

  selectedRow: string;
  DeleteSchedule(ReportName_Abs) {
    this.selectedRow = ReportName_Abs + ',';

    if (this.selectedRow != '') {
      const dailogConfig = new MatDialogConfig();
      dailogConfig.disableClose = true;
      dailogConfig.autoFocus = true;
      // dailogConfig.restoreFocus = true;
      dailogConfig.width = "40%";
      dailogConfig.data = { title: "Confirm Action", message: "Are you sure, you want to delete selected records?" };

      this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          this.DeleteScheduler(this.selectedRow).subscribe((res: any) => {
            this.isLoading = true;

            setTimeout(() => { this.isLoading = false; this.OnReloadRoute(); }, 8000);
          });
        }
      });
    }

  }

  DeleteScheduler(schName: string) {
    this.url = this.baseUrl + 'SchedulerStatus/DeleteSchStat_Main';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = {
      headers: headerOptions
    };
    //let body = '=' + JSON.stringify({
    //  schName: schName
    //});

    //https://social.msdn.microsoft.com/Forums/en-US/06eac7a2-6d92-462e-af73-c314a27bb7f6/the-received-value-is-null-when-i-try-to-post-to-my-web-api?forum=aspwebapi
    //https://www.coderslexicon.com/solving-null-value-when-posting-simple-string-net-web-api/ - IMP POST method sol
    return this.http.post<any>(this.url, '=' + schName, options);
  }
  ///////////////////////////////////// end checkbox
}



export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  description: string;
}
